/*
*
* ©2018 EdgeVerve Systems Limited, Bangalore, India. All Rights Reserved.
*
* The EdgeVerve proprietary software program ("Program"), is protected by copyrights laws, international treaties
* and other pending or existing intellectual property rights in India, the United States and other countries. The Program
* may contain / reference third party or open source components, the rights to which continue to remain with the applicable
* third party licensors or the open source community as the case may be and nothing here transfers the rights to the third party
* and open source components, except as expressly permitted. Any unauthorized reproduction, storage, transmission in any
* form or by any means (including without limitation to electronic, mechanical, printing, photocopying, recording or 
* otherwise), or any distribution of this Program, or any portion of it, may result in severe civil and criminal penalties, and will be
* prosecuted to the maximum extent possible under the law.
* 
*/
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import * as async from 'async';
import { HeaderService } from './header.service';
import { Router } from '@angular/router';

@Injectable()
export class ProfileService {

  getProfileUrl = `${environment.baseContext}/userprofile`;
  getAppListUrl = `${environment.baseContext}/commapi` + '/appConfig/getUserApps';
  getRoleListUrl = `${environment.baseContext}/commapi` + '/appConfig/getUserRoles';
  getMenuListUrl = `${environment.baseContext}/commapi` + '/appConfig/getAppMenu';
  getUserPermissionsWithRolesUrl = `${environment.baseContext}/commapi` + '/appConfig/getUserPermissions';
  getUIconfigUrl = `${environment.baseContext}/guest/uiconfig`;
  getTenantAppUrl = `${environment.baseContext}/commapi` + '/appConfig/getTenantApp';

  defaultLanguage = 'en_us';
  appTranslateService;

  profileData;
  private profileKey: string;
  private appPermissionsKey: string;

  private _actions: string[];
  private _uiactions: string[];

  public get actions(): string[] {
    return this.fetchAppPermissions().permissions;
  }

  public get uiactions(): string[] {
    return this.fetchAppPermissions().uipermissions;
  }

  public isAuthorized(action): boolean {
    let actions = this.fetchAppPermissions().permissions;
    if (action && actions && actions.indexOf(action) > -1) {
      return true
    } else {
      return false;
    }
  }

  constructor(private http: HttpClient, private headerService: HeaderService, private router: Router) {
  }

  getUIconfig(): Observable<any> {
    return this.http.get(this.getUIconfigUrl);
  }

  getProfileFromSSO(): Observable<any> {
    return this.http.get(this.getProfileUrl);
  }

  setAppPermissions(appCode, callback, translateService = null) {
    if (this.hasAppChanged(appCode)) {
      this.headerService.hideBreadCrumb();
    }
    this.appTranslateService = translateService;
    var self = this;
    async.parallel({
      permissions: (cb) => {
        self.getUserPermissionsWithRoles(appCode).subscribe((permissions) => {
          cb(null, permissions)
        }, (err) => {
          cb(err);
        });
      },
      menus: (cb) => {
        self.getMenuList(appCode).subscribe((menus) => {
          cb(null, menus);
        }, (err) => {
          cb(err);
        });
      },
      tenantApp: (cb) => {
        self.getTenantApp(appCode).subscribe((tenantApp) => {
          cb(null, tenantApp);
        }, (err) => {
          cb(err);
        });
      }
    }, (err, data: any) => {
      if (err) {
        console.log(err);
        return callback(err);
      }
      self.headerService.changeMenuItems(data.menus);
      self.appPermissionsKey = "appPermissions";
      sessionStorage.setItem(self.appPermissionsKey, JSON.stringify(data.permissions));
      sessionStorage.setItem('tenantApp', JSON.stringify(data.tenantApp));
      callback();
    });
  }

  hasAppChanged(appCode) {
    let oldAppCode = sessionStorage.getItem("appCode");
    let flag = false;
    if (!oldAppCode || oldAppCode !== appCode) {
      flag = true;
    }
    sessionStorage.setItem("appCode", appCode);
    return flag;
  }

  setProfileData(callback) {
    var self = this;
    async.parallel({
      profile: (cb) => {
        self.getProfileFromSSO().subscribe((profile) => {
          cb(null, profile);
        }, (err) => {
          cb(err);
        });
      },
      apps: (cb) => {
        self.getAppList().subscribe((apps) => {
          cb(null, apps);
        }, (err) => {
          cb(err);
        });
      },
      roles: (cb) => {
        self.getRoleList().subscribe((roles) => {
          cb(null, roles);
        }, (err) => {
          cb(err);
        });
      }
    }, (err, data: any) => {
      if (err) {
        console.log(err);
        return callback(false);
      }
      if (data.apps == undefined || data.apps.length == 0 || data.roles == undefined || data.roles.length == 0)
        return this.router.navigate(['/error']);
      data.profile.apps = data.apps;
      data.profile.roles = data.roles;
      self.profileKey = data.profile.client_code.toLowerCase() + "-profile";
      if (data.profile.defaultLocation) {
        sessionStorage.setItem("countryObj", JSON.stringify(data.profile.defaultLocation));
      }
      sessionStorage.setItem(self.profileKey, JSON.stringify(data.profile));
      callback(true);
    });
  }

  fetchProfile() {
    return sessionStorage.getItem(this.profileKey) ? JSON.parse(sessionStorage.getItem(this.profileKey)) : {};
  }

  fetchAppPermissions() {
    return sessionStorage.getItem(this.appPermissionsKey) ? JSON.parse(sessionStorage.getItem(this.appPermissionsKey)) : {};
  }

  clearProfile() {
    Object.keys(sessionStorage).forEach(function (key) {
      sessionStorage.removeItem(key);
    });
  }

  getUserPermissionsWithRoles(appCode) {
    return this.http.get(this.getUserPermissionsWithRolesUrl + "?appCode=" + appCode);
  }

  getAppList() {
    return this.http.get(this.getAppListUrl);
  }

  getMenuList(appCode) {
    return this.http.get(this.getMenuListUrl + "?appCode=" + appCode);
  }

  getTenantApp(appCode) {
    return this.http.get(this.getTenantAppUrl + "?appCode=" + appCode);
  }

  getRoleList() {
    return this.http.get(this.getRoleListUrl);
  }
  getLanguageCode() {
    return this.fetchProfile().language_code || this.defaultLanguage;
  }

}


